import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Container, Grid } from "semantic-ui-react";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import PaginatedTable from "~/components/PaginatedTable";
import MlsServiceLogIndexStore from "../stores/MlsServiceLogIndexStore";
import MlsServiceLogTable from "../components/MlsServiceLogTable";

@observer
class MlsServiceLogIndexPage extends Component {
  componentDidMount() {
    const { showError, tourId, mlsServiceLogIndexStore } = this.props;
    const { mlsServiceLogStore } = mlsServiceLogIndexStore;

    mlsServiceLogStore.updateSearchParams({ tourId });

    mlsServiceLogStore.loadIndex().catch(error => showError(error.message));
  }

  render() {
    const { showError, mlsServiceLogIndexStore } = this.props;
    const { mlsServiceLogStore, isLoading } = mlsServiceLogIndexStore;
    const { mlsServiceLogs, pagination } = mlsServiceLogStore;

    if (isLoading) {
      return <LoadingWrapper loading />;
    }

    if (!mlsServiceLogs) {
      return <p>No Mls service logs</p>;
    }

    return (
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <h2>Mls service logs</h2>

              <PaginatedTable
                totalItemsCount={mlsServiceLogs.length}
                pagination={pagination}
                changePageCallback={page =>
                  mlsServiceLogStore.changePage(page).catch(error => showError(error.message))
                }
              >
                <MlsServiceLogTable mlsServiceLogs={mlsServiceLogs} />
              </PaginatedTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

MlsServiceLogIndexPage.propTypes = {
  showError: PropTypes.func.isRequired,
  tourId: PropTypes.number.isRequired,
  mlsServiceLogIndexStore: PropTypes.instanceOf(MlsServiceLogIndexStore),
};

export default ErrorWrapper(MlsServiceLogIndexPage);
